<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <v-card height="60">
      <v-footer
        absolute
        class="font-weight-medium white--text px-0"
        color="primary"
      >
        <v-col
          class="text-center px-0"
          cols="12"
        >
          &#9400; Copyright {{ new Date().getFullYear() }} Siam Premium Outlets Bangkok
        </v-col>
      </v-footer>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
}
</script>

<style scoped>

#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: white;
  background-color:#fff;
  text-align: center;
  color: #000;
}
</style>